<template>
    <!--客户成套设备租赁列表-->
  <layout activeLabel="成套设备租赁">
<!--    <div class="btnGroup">-->
<!--      <div-->
<!--        class="btnTab"-->
<!--        @click="statusChange(item)"-->
<!--        :class="item.label == activeTab ? 'active' : ''"-->
<!--        v-for="(item, index) in tabs"-->
<!--        :key="index"-->
<!--      >-->
<!--        {{ item.label }}-->
<!--        ({{item.status==null?buttonSize.khctnull:item.status==7?buttonSize.khct7-->
<!--          :item.status==0?buttonSize.khct0-->
<!--              :item.status==1?buttonSize.khct1-->
<!--                  :item.status==2?buttonSize.khct2-->
<!--                      :item.status==3?buttonSize.khct3-->
<!--                          :item.status==24?buttonSize.khct24-->
<!--                              :item.status==34?buttonSize.khct34-->
<!--                                  :item.status==5?buttonSize.khct6-->
<!--                                      :item.status==70?buttonSize.khct70-->
<!--                                          :item.status==8?buttonSize.khct8:0-->
<!--          }})-->
<!--      </div>-->

<!--    </div>-->
    <div class="title-box flex-row">
      <span class="tit">订单列表</span>

    </div>
      <div class="btnGroup">

         <div style="margin-right: 20px">
           订单编号：<el-input v-model="query.number" placeholder="请输入订单编号" clearable @keyup.enter.native="getOrderList1"
                              style="width: 200px;" />
         </div>
        厂商： <el-input v-model="query.factoryName" placeholder="请输入厂商" clearable @keyup.enter.native="getOrderList1"
                  style="width: 200px;" />
          <el-button type="primary" plain style="margin-left: 10px;" @click="getOrderList1">查询
          </el-button>

      </div>

    <div class="deviceTable">
      <el-table :data="tableData" stripe>
        <el-table-column
          type="index"
          align="center"
          label="序号"
          :index="count"
        ></el-table-column>
<!--        <el-table-column align="center" label="订单名称" prop="orderNo">-->
<!--          <template scope="{row}">-->
<!--            <span>{{-->
<!--              row.vArray == 2 ? row.orderNo+ "合并订单" : row.orderNo-->
<!--            }}</span>-->
<!--            <span v-if="row.status == 60">(续)</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column align="center" label="订单编号" prop="number">
        </el-table-column>

        <el-table-column
            align="center"
            label="厂商"
            width="280px"
            prop="orderFactory.factoryName"
        ></el-table-column>
        <el-table-column
            align="center"
            label="下单人名称"
            prop="createUsername"
        ></el-table-column>
        <el-table-column
            align="center"
            label="电话"
            prop="phone"
        ></el-table-column>

        <el-table-column label="下单时间" align="center">
          <template slot-scope="scope">
            {{ formatMomentTime(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="留言" prop="remark">
        </el-table-column>
<!--          <el-table-column label="创建时间" align="center" prop="createTime" />-->

<!--        <el-table-column align="center" label="租赁时长" prop="name">-->
<!--          <template scope="{row}">-->
<!--            <div class="time-line">-->
<!--              <div class="count">-->
<!--                {{ row.orderPro && row.orderPro.duration }}月-->
<!--              </div>-->
<!--            </div>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          align="center"-->
<!--          label="订单价格"-->
<!--          prop="advance"-->
<!--        ></el-table-column>-->
<!--        <el-table-column align="center" label="当前状态" prop="desc">-->
<!--          <template slot-scope="scope">-->
<!--              {{scope.row.orderSatus == 0 ? '未确认提交': scope.row.orderSatus == 1 ? '待厂商确认' : scope.row.orderSatus == 2 ? '待平台签约'-->
<!--              : scope.row.orderSatus == 3 ? '待客户支付租金' : scope.row.orderSatus == 24 ? '待厂商支付服务费'-->
<!--                  : scope.row.orderSatus == 34 ? '待平台确认服务费': scope.row.orderSatus == 5 ? '待厂商安装验收'-->
<!--                      : scope.row.orderSatus == 6 ? '待客户用电完成' : scope.row.orderSatus == 7 ? '已完成'-->
<!--                          : scope.row.orderSatus == 8 ? '已完成(已评价)' : scope.row.orderSatus == 70 ? '中止订单' : '其他'}}-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column align="center" label="操作" prop="desc">
          <template scope="{row}">
            <div class="btns">
              <span class="btn" @click="handleDetail(row)">查看</span>
              <span
                class="btn error"
                v-show="row.status == '未提交申请' || row.status == '待确定'"
                >取消</span
              >
              <span class="btn" v-show="row.status == '已完成'">续费</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div
        style="display: flex; justify-content: center;margin-top: 20px;"
        v-if="total > query.pageSize"
      >
        <el-pagination
          background
          layout="prev, pager, next,total"
          :total="total"
          :page-size="query.pageSize"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </layout>
</template>

<script>
import layout from "./index.vue";
import { orderListApi } from "../../http/api/ordinary.js";
import {getButtonSizeApi} from "@/http/factory/add-eme";
import moment from 'moment'
export default {
  name: "leaveMessage",
  components: {
    layout,
  },
  data() {
    return {
      activeTab: "全部状态",
      tabs: [
        {
          label: "全部状态",
          status: null,
        },
        {
          label: "未确认提交",
          status: 0,
        },
        {
          label: "待确认",
          status: 1,
        },
        {
          label: "待签约",
          status: 2,
        },
        {
          label: "待客户支付租金",
          status: 3,
        },
        {
          label: "待厂商支付服务费",
          status: 24,
        },
        {
          label: "待平台确认服务费",
          status: 34,
        },
        {
          label: "待厂商安装验收",
          status: 5,
        },
        {
          label: "待客户用电完成",
          status: 6,
        },
        {
          label: "已完成",
          status: 7,
        },
        {
          label: "已评价",
          status: 8,
        },
        {
          label: "中止订单",
          status: 70,
        },
      ],
      tableData: [],
        queryParams:{
            projectname:null,
        },
      buttonSize:[],
        buttonSize1:[],
        buttonSize0:[],
      query: {
        pageSize: 15,
        pageNum: 1,
      },
      total: 0,
    };
  },
  created() {
    this.getOrderList();
    // this.getNotifyButton();
  },
  methods: {

    formatMomentTime(time) {
      return moment(time).format('YYYY-MM-DD HH:mm:ss')
    },
    getType(val) {
      // return moment(time).format('YYYY-MM-DD HH:mm:ss')
    },
      getNotifyButton(){
          // Notification.closeAll();
          this.$notify.closeAll()
          this.getButtonSize1();
      },


      // getButtonSize1(){
      //     getButtonSizeApi({
      //         orderType:1,
      //         superType: 0,
      //     }).then(response=>{
      //         // console.log(response)
      //         this.buttonSize1=response;
      //         let that;
      //         that=this;
      //         this.$notify({
      //             title: "应急保电待办",
      //             dangerouslyUseHTMLString: true,
      //             message: "<span>您的应急保电订单处于待提交状态的有<b style='color:  red'>"+this.buttonSize1.khyj0+"条</b></span><br>"+
      //                 "<span>处于待支付租金状态的有<b style='color:  red'>"+this.buttonSize1.khyj3+"条</b></span><br>"+
      //                 "<span>处于待收货状态的有<b style='color:  red'>"+this.buttonSize1.khyj6+"条</b></span><br>"+
      //                 "<span>处于待确认用电完成的订单有<b style='color:  red'>"+this.buttonSize1.khyj11+"条</b></span><br>"+
      //                 "<span>处于待收款的订单有<b style='color:  red'>"+this.buttonSize1.khyj29+"条</b></span><br>"
      //             ,
      //             duration: 0,
      //             onClick(){
      //                 that.$router.push({
      //                     path:"/personalCenter/orderPower",
      //                 });
      //             }
      //         });
      //     })
      //     getButtonSizeApi({
      //         orderType:0,
      //         superType: 0,
      //     }).then(response=>{
      //         // console.log(response)
      //         this.buttonSize0=response;
      //         let that;
      //         that=this;
      //         this.$notify({
      //             title: "成套设备待办",
      //             dangerouslyUseHTMLString: true,
      //             message:  "<span>您的成套设备订单处于待提交状态的有<b style='color:  red'>"+this.buttonSize0.khct0+"条</b></span><br>"+
      //                 "<span>处于待支付状态的有<b style='color:  red'>"+this.buttonSize0.khct3+"条</b></span><br>"+
      //                 "<span>处于待确认用电完成状态的订单有<b style='color:  red'>"+this.buttonSize0.khct6+"条</b></span><br>"
      //             ,
      //             duration: 0,
      //             onClick(){
      //                 that.$router.push({
      //                     path: "/personalCenter/orderDevice",
      //
      //                 });
      //             }
      //         });
      //     })
      // },
      getOrderList1(){
          this.query.pageNum=1;

          this.getOrderList();
      },
    count(index) {
      return (this.query.pageNum - 1) * this.query.pageSize + index + 1;
    },
    handleDetail(row) {

        this.$router.push({
          path: "/ordinaryUser/shopList",
          query: {
            orderId: row.id,
          },
        });

    },
    getStatus(status, sta, row) {
      for (let item of this.tabs) {
        if (status == 50) {
          if (sta == 1) {
            return "终止订单（待厂商确认）";
          }
          if (sta == 2) {
            return "终止订单（待平台确认）";
          }
          if (sta == 3) {
            if (row.statuson == 1) {
              return "终止订单（待厂商确认协议）";
            } else {
              return "终止订单（待确认协议）";
            }
          }
          if (sta == 4) {
            return "已终止（退款中）";
          }
          if (sta == 5) {
            if (row.statuson == 3) {
              return "已终止";
            } else {
              return "已终止（待确认收款）";
            }
          }
          if (sta == 6) {
            return "已终止";
          }
          return "终止订单";
        }
        if (item.status == status) {
          return item.label;
        }
      }
    },

      getButtonSize(){
          getButtonSizeApi({
              orderType: 0,
              superType: 0,
              projectname:this.queryParams.projectname,
          }).then(response=>{
              // console.log(response)
              this.buttonSize=response;
          })
      },
    getOrderList() {
      // this.query.projectname=this.queryParams.projectname;
      orderListApi(this.query).then((res) => {
        this.tableData = res.rows;

        this.total = res.total;
      });

    },
    handleCurrentChange(val) {
      this.query.pageNum = val;
      this.getOrderList();
    },
    // statusChange(item) {
    //   this.activeTab = item.label;
    //   this.query.orderSatus = item.status;
    //   this.getOrderList();
    // },
  },
};
</script>
<style lang="less" scoped>
.btnGroup {
  //border-bottom: 1px solid #f4f4f4;
  padding:  0.2rem 0.4rem 0.2rem;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .btnTab {
    margin-top: 20px;
    margin-right: 20px;
    padding: 6px 10px;
    border-radius: 0.06rem;
    text-align: center;
    line-height: 0.2rem;
    font-size: 15px;
    background: #ebebeb;
    color: #7d7d7d;
    cursor: pointer;

    &.active {
      color: #fff;
      background: #818181;
    }
  }
}

.deviceTable {
  padding: 0.1rem 0.4rem 0.4rem;
  box-sizing: border-box;
  min-height: calc(100vh - 2.5rem);
}

.deviceCard {
  padding-right: 1rem;
  padding-top: 0.48rem;
  box-sizing: border-box;
  display: flex;
}

.row-merge {
  padding: 0.18rem 0.33rem 0;
  display: flex;
  flex-wrap: wrap;

  &.order-row0 {
    background: #f2f2f2;
  }

  .order-item {
    width: 2.3rem;
    padding-bottom: 0.18rem;
    display: inline-flex;
    align-items: center;
  }

  .order-name {
    padding: 0 0.18rem;
    font-size: 0.14rem;
    color: #000;
  }
}

.logo {
  width: 0.38rem;
  min-width: 0.38rem;
  height: 0.38rem;
  border-radius: 0.07rem;
}

.nameBox {
  display: flex;
  align-items: center;

  .orderName {
    line-height: 0.38rem;
    padding-left: 0.14rem;
    color: #000;
    font-size: 0.14rem;
  }
}

.btns {
  .btn {
    padding: 0 0.16rem;
    color: #000;
    cursor: pointer;

    &.error {
      color: #f53232;
    }
  }
}

.time-line {
  .count {
    line-height: 0.2rem;
    padding-bottom: 0.09rem;
  }

  .status {
    color: #ff6b4a;
  }
}
.title-box {
  line-height: 0.74rem;
  border-bottom: 1px solid #eaeaea;
  justify-content: space-between;
  padding: 0 0.25rem;

  span {
    font-size: 0.14rem;
    color: #434343;
  }

  .tit {
    font-size: 0.18rem;
    color: #000000;
  }
}
</style>
